import React from "react";
const Card: React.FC<{ label: string; value: string; iconClass: string; isEditing: boolean; name: string; onChange: (e: React.ChangeEvent<HTMLInputElement>) => void; }> = ({ label, value, iconClass, isEditing, name, onChange }) => (
  <div className="card">
    <div className="card-inner">
      <i className={`icon ${iconClass}`} aria-hidden="true"></i>
      <div>
        <label className="label" htmlFor={name}>
          {label}:
        </label>
        {isEditing ? (
          <input className="input" type="text" name={name} id={name} value={value} onChange={onChange} aria-label={`Edit ${label}`} />
        ) : (
          <p className="value">{value}</p>
        )}
      </div>
    </div>
  </div>
);
export default Card;